export const SPONSORED_PRODUCT_MODAL_ID = {
    listingTopHead: 'listingTopHead',
    listingTop: 'listingTop',
    listingPage: 'listingPage',
    srpHeader: 'srpHeader',
} as const;
